import LockupTagsOnMobile from './lockupTagsOnMobile'

export default LockupTagsOnMobile
